export const CREATE_BIBLIO_ENTITY = "CREATE_BIBLIO_ENTITY"
export const CLEAR_STATES = 'CLEAR_STATES'
export const CREATE_ENTITY_SUCCESS = 'CREATE_ENTITY_SUCCESS'
export const CREATE_ENTITY_ERROR = 'CREATE_ENTITY_ERROR'
export const DELETE_ENTITY_SUCCESS = 'DELETE_ENTITY_SUCCESS'
export const DELETE_ENTITY_ERROR = 'DELETE_ENTITY_ERROR'
export const UPDATE_ENTITY_SUCCESS = 'UPDATE_ENTITY_SUCCESS'
export const UPDATE_ENTITY_ERROR = 'UPDATE_ENTITY_ERROR'
export const DELETE_TAGS_CATS = 'DELETE_TAGS_CATS'